/* eslint-disable default-param-last */
import { FETCH_PROVIDERS } from '../types'

export function providers(state = [], action) {
  switch (action.type) {
    case FETCH_PROVIDERS:
      return action.data
    default:
      return state
  }
}
